/* =========================================================================
   Realizzandoo — Configurator v4 ("Atelier Mode")
   - Dynamic step navigation
   - Live preview: variant image + name overlay in selected color (Caveat)
   - No hardcoded "Lucia" references; uses placeholder for empty preview
   ========================================================================= */
(function () {
  'use strict';

  // Color name → hex map (matching brand swatches)
  var COLOR_MAP = {
    'bianco': '#FFFFFF', 'white': '#FFFFFF',
    'nero': '#0F0F0F', 'black': '#0F0F0F',
    'rosa': '#F8B4C8', 'pink': '#F8B4C8',
    'rosa-chiaro': '#FCD7E2', 'rosa-pastello': '#FCD7E2',
    'rosso': '#D14B4B', 'red': '#D14B4B',
    'arancione': '#F2925E', 'orange': '#F2925E',
    'giallo': '#F4D35E', 'yellow': '#F4D35E',
    'verde': '#5BB191', 'green': '#5BB191',
    'verde-chiaro': '#A3D9B1',
    'celeste': '#7FCDE3', 'azzurro': '#7FCDE3',
    'blu': '#3F5BAE', 'blue': '#3F5BAE',
    'viola': '#7B66B8', 'purple': '#7B66B8',
    'lilla': '#C1A3D9',
    'fucsia': '#D4458F', 'magenta': '#D4458F',
    'beige': '#E8D7C0',
    'marrone': '#8C5A3A', 'brown': '#8C5A3A',
    'oro': '#D4AF37', 'gold': '#D4AF37',
    'argento': '#C4C4C4', 'silver': '#C4C4C4',
    'grigio': '#9E9690', 'gray': '#9E9690', 'grey': '#9E9690',
    'multicolor': 'linear-gradient(135deg, #F8B4C8 0%, #F4D35E 25%, #5BB191 50%, #7FCDE3 75%, #7B66B8 100%)'
  };

  function colorForValue(value) {
    if (!value) return '#3f388b';
    var key = value.toString().toLowerCase().trim().replace(/\s+/g, '-');
    if (COLOR_MAP[key]) return COLOR_MAP[key];
    // try without hyphens
    var simple = key.replace(/-/g, '');
    for (var k in COLOR_MAP) if (k.replace(/-/g, '') === simple) return COLOR_MAP[k];
    return '#3f388b';
  }

  // Global safety net: intercept any submit on .rlz-cfg__form regardless of init order.
  // Prevents native form submission to /cart/add that redirects to /cart.
  document.addEventListener('submit', function (e) {
    var f = e.target && e.target.closest && e.target.closest('.rlz-cfg__form, [data-rlz-cfg-form]');
    if (!f) return;
    e.preventDefault();
    e.stopPropagation();
    // Try to add via AJAX. If fails, open cart drawer with current state (no nav).
    fetch('/cart/add.js', { method: 'POST', body: new FormData(f) })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data && data.id) {
          // Update cart count
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
          });
          // Open cart drawer (preferred) or fallback to checkout
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.open === 'function') {
            // Re-fetch and re-render drawer section first
            var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
            fetch(rootPath + '?section_id=cart-drawer', { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
              var dom = new DOMParser().parseFromString(html, 'text/html');
              var fresh = dom.querySelector('cart-drawer');
              if (fresh && drawer) {
                drawer.innerHTML = fresh.innerHTML;
              }
              drawer.classList.add('animate', 'active');
              document.body.classList.add('overflow-hidden');
            }).catch(function () { drawer.classList.add('animate', 'active'); });
          } else {
            window.location.href = '/checkout';
          }
        } else {
          alert((data && data.description) || 'Errore. Riprova.');
        }
      })
      .catch(function () { alert((window.rlzI18n && window.rlzI18n.error_network_retry) || 'Network error. Please try again.'); });
  }, true); // capture phase, runs before any other handler

  document.querySelectorAll('.rlz-cfg').forEach(initConfigurator);

  function initConfigurator(root) {
    var totalSteps = parseInt(root.getAttribute('data-total-steps'), 10) || 3;
    var panels = root.querySelectorAll('[data-rlz-panel]');
    var ticks = root.querySelectorAll('.rlz-cfg__step-tick');
    var form = root.querySelector('[data-rlz-cfg-form]');
    var variantSelect = root.querySelector('[data-rlz-variant-select]');
    var nameInput = root.querySelector('[data-rlz-name-input]');
    var charCount = root.querySelector('[data-rlz-char-count]');
    var reviewEl = root.querySelector('[data-rlz-review]');
    var reviewPrice = root.querySelector('[data-rlz-review-price]');
    var anotherEl = root.querySelector('[data-rlz-another]');
    var heroEl = root.querySelector('[data-rlz-hero]');
    var wizardEl = root.querySelector('[data-rlz-wizard]');
    var previewText = root.querySelector('[data-rlz-preview-text]');
    var letteringPlaceholder = previewText ? previewText.textContent.trim() : '';
    var stepCounter = root.querySelector('[data-rlz-step-counter]');
    var currentStep = 0;
    var selectedOptions = {};
    var selectedNameColor = '#3f388b';

    // ===== Start button =====
    var startBtn = root.querySelector('[data-rlz-start]');
    if (startBtn) {
      startBtn.addEventListener('click', function () {
        if (heroEl) heroEl.style.display = 'none';
        if (wizardEl) wizardEl.style.display = '';
        if (form) form.style.display = '';
        goToStep(1);
      });
    }

    // ===== Swatch clicks (image + text + color name swatches) =====
    root.addEventListener('click', function (e) {
      var imgSwatch = e.target.closest('.rlz-cfg__img-swatch');
      if (imgSwatch) { handleSwatchClick(imgSwatch, /*isColor*/ false); return; }

      var colorSwatch = e.target.closest('[data-rlz-color-swatch]');
      if (colorSwatch) { handleSwatchClick(colorSwatch, /*isColor*/ true); return; }

      var swatch = e.target.closest('.rlz-cfg__swatch');
      if (swatch) { handleSwatchClick(swatch, false); return; }
    });

    function handleSwatchClick(swatch, isColor) {
      var position = parseInt(swatch.getAttribute('data-option-position'), 10);
      var value = swatch.getAttribute('data-value');
      var group = swatch.closest('.rlz-cfg__option-group') || swatch.parentElement;
      if (group) {
        group.querySelectorAll('.rlz-cfg__swatch, .rlz-cfg__img-swatch, [data-rlz-color-swatch]').forEach(function (s) {
          s.classList.remove('is-selected');
        });
      }
      swatch.classList.add('is-selected');
      // tiny pop feedback
      swatch.style.transform = 'scale(0.95)';
      setTimeout(function () { swatch.style.transform = ''; }, 150);

      updateLabel(position, value);
      selectedOptions['option' + position] = value;

      if (isColor) {
        selectedNameColor = colorForValue(value);
        if (previewText) {
          var isGradient = selectedNameColor.indexOf('linear-gradient') === 0 || selectedNameColor.indexOf('conic-gradient') === 0;
          // Always solid fill, no outline
          previewText.style.webkitTextStroke = '0';
          previewText.style.textStroke = '0';
          if (isGradient) {
            previewText.style.color = 'transparent';
            previewText.style.background = selectedNameColor;
            previewText.style.webkitBackgroundClip = 'text';
            previewText.style.backgroundClip = 'text';
            // Gradient su sfondo bianco → contrast critical: aggiunge ombra leggera per leggibilità
            previewText.style.filter = 'drop-shadow(0 1px 2px rgba(0,0,0,0.25))';
          } else {
            previewText.style.color = selectedNameColor;
            previewText.style.background = 'transparent';
            previewText.style.webkitBackgroundClip = 'border-box';
            previewText.style.backgroundClip = 'border-box';
            previewText.style.filter = '';
          }
        }
        // Adapt preview card background for contrast with light colors
        var letteringCard = root.querySelector('.rlz-cfg__lettering');
        if (letteringCard && !isGradient) {
          var hex2 = selectedNameColor.match(/^#([0-9a-f]{6})$/i);
          var brightness2 = 999;
          if (hex2) {
            var rr = parseInt(hex2[1].slice(0,2), 16);
            var gg = parseInt(hex2[1].slice(2,4), 16);
            var bb = parseInt(hex2[1].slice(4,6), 16);
            brightness2 = (rr * 299 + gg * 587 + bb * 114) / 1000;
          }
          letteringCard.classList.toggle('is-dark-bg', brightness2 > 200);
        }
      }

      updateVariant();
    }

    function updateLabel(position, value) {
      var label = root.querySelector('[data-rlz-selected-label="' + position + '"]');
      if (label) label.textContent = value;
    }

    // ===== Navigation =====
    var nameErrEl = root.querySelector('[data-rlz-name-error]');
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-rlz-next]')) {
        e.preventDefault();
        // Validate name step (must have text before going to review)
        if (currentStep === totalSteps - 1 && nameInput && !nameInput.value.trim()) {
          nameInput.focus();
          nameInput.classList.add('rlz-cfg__name-input--error');
          if (nameErrEl) nameErrEl.style.display = '';
          setTimeout(function () {
            nameInput.classList.remove('rlz-cfg__name-input--error');
            if (nameErrEl) nameErrEl.style.display = 'none';
          }, 3500);
          return;
        }
        goToStep(currentStep + 1);
      }
      if (e.target.closest('[data-rlz-back]')) {
        e.preventDefault();
        goToStep(currentStep - 1);
      }
      if (e.target.closest('[data-rlz-another-yes]')) {
        e.preventDefault();
        resetConfigurator();
      }
    });

    // ===== Name input + live lettering preview + heart suffix =====
    var heartCheckbox = root.querySelector('[data-rlz-heart]');
    var finalNameInput = root.querySelector('[data-rlz-final-name]');

    function computeFinalName() {
      var raw = nameInput ? nameInput.value.trim() : '';
      if (!raw) return '';
      // Opt-IN: cuore solo se checkbox selezionata
      var wantsHeart = !!(heartCheckbox && heartCheckbox.checked);
      var hasBackslash = raw.charAt(raw.length - 1) === '\\';
      if (wantsHeart && !hasBackslash) return raw + '\\';
      if (!wantsHeart && hasBackslash) return raw.slice(0, -1);
      return raw;
    }

    function syncPreview() {
      var final = computeFinalName();
      var raw = nameInput ? nameInput.value : '';
      if (charCount) charCount.textContent = raw.length;
      if (previewText) {
        previewText.textContent = final || letteringPlaceholder;
        previewText.classList.toggle('is-placeholder', !final);
        previewText.style.transform = 'scale(1.03)';
        setTimeout(function () { previewText.style.transform = ''; }, 150);
      }
      if (finalNameInput) finalNameInput.value = final;
    }

    if (nameInput) {
      nameInput.addEventListener('input', syncPreview);
    }
    if (heartCheckbox) {
      heartCheckbox.addEventListener('change', syncPreview);
    }

    // ===== Add and personalize another =====
    var addAndPersonalizeBtn = root.querySelector('[data-rlz-add-and-personalize]');
    if (addAndPersonalizeBtn) {
      addAndPersonalizeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        addToCartAjax(function () { showAddAnother(); });
      });
    }

    // ===== Form submit = add + go to checkout =====
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        addToCartAjax(function () { window.location.href = '/checkout'; });
      });
    }

    function addToCartAjax(onSuccess) {
      var allBtns = root.querySelectorAll('.rlz-cfg__btn--add, .rlz-cfg__btn--add-another');
      allBtns.forEach(function (b) { b.disabled = true; });
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data.id) { updateCartCount(); if (onSuccess) onSuccess(data); }
          else { alert(data.description || (window.rlzI18n && window.rlzI18n.error_retry) || 'Error. Please try again.'); allBtns.forEach(function (b) { b.disabled = false; }); }
        })
        .catch(function () { alert((window.rlzI18n && window.rlzI18n.error_network_retry) || 'Network error. Please try again.'); allBtns.forEach(function (b) { b.disabled = false; }); });
    }

    function goToStep(step) {
      // clamp
      if (step < 1) step = 1;
      if (step > totalSteps) step = totalSteps;

      var targetPanel = root.querySelector('[data-rlz-panel="' + step + '"]');
      if (!targetPanel) return;

      if (step === totalSteps) buildReview();

      panels.forEach(function (p) { p.classList.remove('is-active'); });
      targetPanel.classList.add('is-active');

      ticks.forEach(function (d) {
        var tickStep = parseInt(d.getAttribute('data-step'), 10);
        d.classList.remove('is-active', 'is-done');
        if (tickStep === step) d.classList.add('is-active');
        else if (tickStep < step) d.classList.add('is-done');
      });

      if (stepCounter) {
        stepCounter.textContent = step;
      }

      currentStep = step;
      updateSwatchAvailability();
      // soft scroll only if necessary
      var r = targetPanel.getBoundingClientRect();
      if (r.top < 0 || r.bottom > window.innerHeight) {
        targetPanel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    function updateVariant() {
      if (!variantSelect) return;
      var options = variantSelect.querySelectorAll('option');
      for (var i = 0; i < options.length; i++) {
        var opt = options[i];
        if (opt.disabled) continue;
        var match = true;
        for (var key in selectedOptions) {
          var idx = key.replace('option', '');
          var dataVal = opt.getAttribute('data-option' + idx);
          if (dataVal && dataVal !== selectedOptions[key]) { match = false; break; }
        }
        if (match) {
          variantSelect.value = opt.value;
          if (reviewPrice) reviewPrice.textContent = opt.getAttribute('data-price');
          // Sync hero + sticky + atc button prices
          var variantData = {
            id: parseInt(opt.value, 10),
            price: parseInt(opt.getAttribute('data-price-raw'), 10),
            compare_at_price: parseInt(opt.getAttribute('data-compare-raw'), 10) || null,
            available: !opt.disabled,
          };
          document.dispatchEvent(new CustomEvent('rlz:variant-change', { detail: { variant: variantData } }));
          break;
        }
      }
      updateSwatchAvailability();
    }

    function updateSwatchAvailability() {
      if (!variantSelect) return;
      var options = variantSelect.querySelectorAll('option');
      root.querySelectorAll('.rlz-cfg__img-swatch, .rlz-cfg__swatch, [data-rlz-color-swatch]').forEach(function(sw) {
        var position = parseInt(sw.getAttribute('data-option-position'), 10);
        var value = sw.getAttribute('data-value');
        if (!value || !position) return;
        var hypo = Object.assign({}, selectedOptions);
        hypo['option' + position] = value;
        var found = false;
        for (var i = 0; i < options.length; i++) {
          var opt = options[i];
          if (opt.disabled) continue;
          var match = true;
          for (var key in hypo) {
            var idx = key.replace('option', '');
            var dataVal = opt.getAttribute('data-option' + idx);
            if (dataVal !== hypo[key]) { match = false; break; }
          }
          if (match) { found = true; break; }
        }
        sw.classList.toggle('is-unavailable', !found);
        if (sw.tagName === 'BUTTON') sw.disabled = !found;
      });
    }

    function buildReview() {
      if (!reviewEl) return;
      var html = '';
      root.querySelectorAll('.rlz-cfg__img-swatch.is-selected, .rlz-cfg__swatch.is-selected, [data-rlz-color-swatch].is-selected').forEach(function (s) {
        var group = s.closest('.rlz-cfg__option-group');
        var panelTitle = '';
        if (group) {
          var head = group.parentElement.querySelector('.rlz-cfg__panel-title');
          if (head) panelTitle = head.textContent.trim();
        }
        html += '<div class="rlz-cfg__review-row">' +
                  '<span class="rlz-cfg__review-label">' + escapeHtml(panelTitle) + '</span>' +
                  '<span class="rlz-cfg__review-value">' + escapeHtml(s.getAttribute('data-value')) + '</span>' +
                '</div>';
      });
      if (nameInput && nameInput.value.trim()) {
        var displayName = computeFinalName();
        html += '<div class="rlz-cfg__review-row rlz-cfg__review-row--name">' +
                  '<span class="rlz-cfg__review-label">Nome o Scritta</span>' +
                  '<span class="rlz-cfg__review-value rlz-cfg__review-name" style="color:' + selectedNameColor + '">' +
                    escapeHtml(displayName) +
                  '</span>' +
                '</div>';
      }
      reviewEl.innerHTML = html;
      if (reviewPrice && variantSelect) {
        var sel = variantSelect.options[variantSelect.selectedIndex];
        if (sel) reviewPrice.textContent = sel.getAttribute('data-price');
      }
    }

    function showAddAnother() {
      var step4Actions = root.querySelector('[data-rlz-step4-actions]');
      var navBack = root.querySelector('[data-rlz-panel="' + totalSteps + '"] [data-rlz-back]');
      if (step4Actions) step4Actions.style.display = 'none';
      if (navBack) navBack.style.display = 'none';
      if (anotherEl) {
        anotherEl.style.display = 'block';
        var msg = anotherEl.querySelector('[data-rlz-another-msg]');
        if (msg && nameInput && nameInput.value.trim()) {
          msg.textContent = '"' + nameInput.value.trim() + '" aggiunto al carrello!';
        }
        spawnConfetti();
      }
    }

    function resetConfigurator() {
      if (nameInput) nameInput.value = '';
      if (charCount) charCount.textContent = '0';
      if (finalNameInput) finalNameInput.value = '';
      if (heartCheckbox) heartCheckbox.checked = false;
      if (previewText) {
        previewText.textContent = letteringPlaceholder;
        previewText.classList.add('is-placeholder');
        previewText.style.color = selectedNameColor;
      }
      if (anotherEl) anotherEl.style.display = 'none';
      var step4Actions = root.querySelector('[data-rlz-step4-actions]');
      var navBack = root.querySelector('[data-rlz-panel="' + totalSteps + '"] [data-rlz-back]');
      if (step4Actions) step4Actions.style.display = '';
      if (navBack) navBack.style.display = '';
      root.querySelectorAll('.rlz-cfg__btn--add, .rlz-cfg__btn--add-another').forEach(function (b) { b.disabled = false; });
      goToStep(1);
    }

    function updateCartCount() {
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        document.querySelectorAll('.cart-count, .cart-item-count, [data-cart-count], #cart-icon-bubble .cart-count-bubble span:first-child').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      }).catch(function () {});
    }

    function escapeHtml(str) { var d = document.createElement('div'); d.textContent = str || ''; return d.innerHTML; }

    function spawnConfetti() {
      var container = root.querySelector('[data-rlz-confetti]');
      if (!container) return;
      var colors = ['#12caa1', '#3f388b', '#8278f4', '#E8756D', '#F4D35E', '#F8B4C8', '#7FCDE3'];
      for (var i = 0; i < 26; i++) {
        var piece = document.createElement('div');
        piece.className = 'rlz-confetti-piece';
        piece.style.left = Math.random() * 100 + '%';
        piece.style.width = (6 + Math.random() * 6) + 'px';
        piece.style.height = (6 + Math.random() * 6) + 'px';
        piece.style.background = colors[Math.floor(Math.random() * colors.length)];
        piece.style.animationDelay = Math.random() * 0.5 + 's';
        piece.style.setProperty('--fall-duration', (1 + Math.random()) + 's');
        piece.style.setProperty('--rotation', (360 + Math.random() * 720) + 'deg');
        container.appendChild(piece);
      }
      setTimeout(function () { container.innerHTML = ''; }, 2500);
    }
  }
})();
